// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"97767ae4","453":"80e05e06","455":"8bed82a1"}[chunkId] + ".chunk.js";
};